



import React, { useState, useEffect } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

const TimelineHeader = ({ meeting }) => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Determine baseLength based on screen width
  const getBaseLength = (width) => {
    if (width >= 360 && width < 550) return 10;
    if (width >= 550 && width < 1199) return 12;
    if (width >= 1199 && width < 1400) return 12;
    if (width >= 1400 && width < 1700) return 10;
    if (width >= 1700 && width < 2000) return 0;
    return 37; // default for large screens or unknown size
  };

  const sliceLength = Math.floor(screenSize / getBaseLength(screenSize));
  const title = meeting?.title || "";
  const shortTitle = title.length > sliceLength ? `${title.slice(0, sliceLength)}...` : title;

  const popoverHoverFocus = (title) => (
    <Popover id="popover-basic" className="custom-popover">
      <Popover.Body className="popover-body">{title}</Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement="top"
      overlay={popoverHoverFocus(title)}
    >
      <p className="meeting-day meeting-by-user">{shortTitle}</p>
    </OverlayTrigger>
  );
};

export default TimelineHeader;
